import { Base } from '@studiometa/js-toolkit';
import Categories from './Categories.js';
import Travelers from './Travelers.js';
import DatePicker from './DatePicker.js';
import MewsEngine from './MewsEngine.js';
import CustomScrollBar from '#js/atoms/CustomScrollBar.js';
import Voucher from './Voucher.js';

/**
 * @typedef {{}} SearchWidgetProps
 */

/**
 * SearchWidget SearchWidget.
 * @augments {Base<SearchWidgetProps>}
 */
export default class SearchWidget extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'SearchWidget',
    refs: ['btnMobile', 'inputsContainer', 'close[]', 'loader'],
    components: {
      Categories,
      Travelers,
      DatePicker,
      Voucher,
      MewsEngine,
      CustomScrollBar,
    },
    options: {
      submitOnChange: {
        type: Boolean,
        default: false,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.hero = this.$el.closest('.hero');
    this.fixedWidget = document.querySelector('#fixed-widget');
    this.isSticky = false;
    this.dropdowns = [
      this.$children.Categories[0],
      this.$children.Travelers[0],
      this.$children.DatePicker[0],
    ];

    this.updateFixedWidgetVisibility();
  }

  /**
   * Update fixed widget visibility on scroll.
   */
  scrolled() {
    this.updateFixedWidgetVisibility();
  }

  /**
   * Show or hide the fixed widget based on the original's viewport position.
   */
  updateFixedWidgetVisibility() {
    if (!this.fixedWidget) {
      return;
    }

    const { bottom } = this.$el.getBoundingClientRect();
    const shouldBeSticky = bottom < 0;

    if (shouldBeSticky && !this.isSticky) {
      this.isSticky = true;
      this.fixedWidget.classList.add('is-visible');
    } else if (!shouldBeSticky && this.isSticky) {
      this.isSticky = false;
      this.fixedWidget.classList.remove('is-visible');
    }
  }

  /**
   * Send Datalayer on submit !
   */
  onSubmit() {
    const data = new FormData(this.$el);
    const formDataEntries = {};

    for (const [key, value] of data.entries()) {
      formDataEntries[`widget_${key}`] = value;
    }

    window.dataLayer.push({
      event: 'search',
      pageUrl: window.location.href,
      current_destination: window.cs_datalayer.current_destination,
      ...formDataEntries,
    });
  }

  /**
   *
   */
  onCloseClick() {
    this.close();
  }

  /**
   *
   */
  onBtnMobileClick() {
    this.open();
  }

  /**
   * When categories dropdown opened
   * @param {object} props params
   * @param {Array}  props.args current element
   * @returns {void}
   */
  onCategoriesOpen({ args }) {
    this.closeAllDropdown(args[0]);
  }

  /**
   * When datepicker dropdown opened
   * @param {object} props params
   * @param {Array}  props.args current element
   * @returns {void}
   */
  onDatePickerOpen({ args }) {
    this.closeAllDropdown(args[0]);
  }

  /**
   *
   */
  onDatePickerSubmit() {
    if (this.$options.submitOnChange) {
      this.$el.requestSubmit();
    }
  }

  /**
   *
   */
  onVoucherSubmit() {
    if (this.$options.submitOnChange) {
      this.$el.requestSubmit();
    }
  }

  /**
   *
   */
  onTravelersSubmit() {
    if (this.$options.submitOnChange) {
      this.$el.requestSubmit();
    }
  }

  /**
   * When travelers dropdown opened
   * @param {object} props params
   * @param {Array}  props.args current element
   * @returns {void}
   */
  onTravelersOpen({ args }) {
    this.closeAllDropdown(args[0]);
  }

  /**
   * Close all dropdown expect element in param
   * @param  {object} component current Element
   * @returns {void}
   */
  closeAllDropdown(component) {
    this.dropdowns.forEach((element) => {
      if (element !== undefined && element.$id !== component.$id) {
        element.close();
      }
    });
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (ESC) {
      this.close();
    }
  }

  /**
   *
   */
  open() {
    if (this.hero) {
      this.hero.style.zIndex = 1000;
    }
    document.documentElement.classList.add('is-scrolling-down', 'open-search');
    document.documentElement.classList.remove('is-scrolling-up', 'is-near-top', 'is-on-top');
  }

  /**
   *
   */
  close() {
    if (this.hero) {
      this.hero.style.zIndex = '';
    }
    document.documentElement.classList.remove('open-search');
  }
}
